__turbopack_context__.v({
  "main": "Helpdesk-module-scss-module__2d4X3q__main",
});
